import React from 'react';

const PaymentMethods = () => {
  return (
    <section className="py-20 md:py-32 bg-zinc-950">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 lg:px-20">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-yellow-700/20 border border-yellow-600/30 px-4 py-2 mb-6">
            <span className="text-yellow-600 text-sm font-medium">FACILIDADES DE PAGO</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Métodos de Pago
          </h2>
          <p className="text-xl text-white/70 max-w-2xl mx-auto">
            Aceptamos múltiples formas de pago para tu comodidad
          </p>
        </div>

        {/* Payment Methods Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-12">
          {/* Caribe Express */}
          <div className="bg-black border border-white/10 p-6 flex items-center justify-center hover:border-yellow-600/50 transition-all duration-300">
            <div className="text-center">
              <div className="text-white font-bold text-lg mb-2">Caribe</div>
              <div className="text-yellow-600 font-bold text-2xl">EXPRESS</div>
            </div>
          </div>

          {/* BHD */}
          <div className="bg-black border border-white/10 p-6 flex items-center justify-center hover:border-yellow-600/50 transition-all duration-300">
            <div className="text-white font-bold text-3xl">BHD</div>
          </div>

          {/* Western Union */}
          <div className="bg-black border border-white/10 p-6 flex items-center justify-center hover:border-yellow-600/50 transition-all duration-300">
            <div className="text-center">
              <div className="text-yellow-400 font-bold text-sm">Western</div>
              <div className="text-yellow-400 font-bold text-xl">Union</div>
              <div className="text-white text-xs mt-1">WU</div>
            </div>
          </div>

          {/* BanReservas */}
          <div className="bg-black border border-white/10 p-6 flex items-center justify-center hover:border-yellow-600/50 transition-all duration-300">
            <div className="text-white font-bold text-xl">BanReservas</div>
          </div>

          {/* Popular */}
          <div className="bg-black border border-white/10 p-6 flex items-center justify-center hover:border-yellow-600/50 transition-all duration-300">
            <div className="text-center">
              <div className="text-blue-500 font-bold text-2xl">POPULAR</div>
            </div>
          </div>

          {/* Zelle */}
          <div className="bg-black border border-white/10 p-6 flex items-center justify-center hover:border-yellow-600/50 transition-all duration-300">
            <div className="bg-purple-600 text-white font-bold text-2xl px-6 py-2">Zelle</div>
          </div>

          {/* BBVA */}
          <div className="bg-black border border-white/10 p-6 flex items-center justify-center hover:border-yellow-600/50 transition-all duration-300">
            <div className="text-white font-bold text-3xl">BBVA</div>
          </div>

          {/* Bizum */}
          <div className="bg-black border border-white/10 p-6 flex items-center justify-center hover:border-yellow-600/50 transition-all duration-300">
            <div className="text-cyan-400 font-bold text-2xl">bizum</div>
          </div>

          {/* PayPal */}
          <div className="bg-black border border-white/10 p-6 flex items-center justify-center hover:border-yellow-600/50 transition-all duration-300 col-span-2 md:col-span-1">
            <div className="text-center">
              <div className="text-blue-500 font-bold text-xl">Pay</div>
              <div className="text-blue-400 font-bold text-xl">Pal</div>
            </div>
          </div>

          {/* Cash & Cards */}
          <div className="bg-black border border-white/10 p-6 flex items-center justify-center hover:border-yellow-600/50 transition-all duration-300 col-span-2 md:col-span-3">
            <div className="text-center">
              <div className="text-white font-semibold text-lg">Efectivo (USD & DOP)</div>
              <div className="text-white/70 text-sm mt-1">Tarjetas de Crédito y Débito</div>
            </div>
          </div>
        </div>

        {/* Note */}
        <div className="text-center">
          <p className="text-white/60 max-w-2xl mx-auto">
            Todos los pagos son seguros y procesados con los más altos estándares de seguridad. 
            Para pagos internacionales, contáctanos para coordinar el método más conveniente.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PaymentMethods;
